import { type IstanzaSezioneDati } from '@framework/api-client/api/backoffice/schemas/istanzaSezioneDati.ts';
import { FormValidatorBuilder } from '@framework/engine/validator/form-builder/FormValidatorBuilder.ts';
import { yup } from '@framework/validation/initYup.ts';
import { mapDeclarationSections } from './mapDeclarationSections.ts';

/**
 * Crea lo schema di validazione per le dichiarazioni (istanza sezione dati)
 * Versione di Common-Web. A differenza di quella di backoffice, il readonly
 *non* è calcolato in automatico ma deve essere fornito.
 */
export function createDeclarationsSchema(
  declarations: IstanzaSezioneDati[] | null | undefined,
  options: { readonly: boolean },
): yup.ObjectSchema<yup.AnyObject> {
  if (!declarations) return yup.object().shape({}).required().noUnknown();

  const sections = mapDeclarationSections(declarations, options.readonly);

  const { schema } = FormValidatorBuilder.buildSections(sections);

  return schema;
}
